import {
  Box,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
} from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import urls from 'utils/urls'
import { makePostRequest } from 'utils/api'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { makeGetRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function MesObjectifsCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [selected, setSelected] = useState([])

  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert(t('monPatrimoine.selectOneOperation')) // LAP-733 (GE022)
    } else {
      const response = await makePostRequest(
        urls.deleteUserObjectIfs,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('updated Successfully')
        updateReports()
      }
    }
  }
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.myObjectives')}
          </WTypography>
        </Box>

        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('monPatrimoine.patrimonyObjectives')}
          </WTypography>
          <Box className="no-drag">
            <AddObjectForm updateReports={updateReports} />
            <IconButton onClick={deleteBulkOperations}>
              <RemoveCircleIcon sx={{ color: 'gray' }} />
            </IconButton>
          </Box>
        </Box>

        <Box mt={0} minWidth={3} mb={6} height={'85%'} sx={{ overflowX: 'auto' }}>
          <Box className="no-drag">
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: 'unset',
                bgcolor: 'unset',
                '*': { color: 'white !important' },
                pr: '6px',
              }}
            >
              <Table sx={{}} aria-label="spanning table">
                <TableBody
                  sx={{
                    '.MuiTableCell-root': {
                      padding: '0px',
                    },
                  }}
                >
                  {oldData?.map((el) => (
                    <TableRow key={el.id}>
                      <TableCell colSpan={2}>
                        <FormControlLabel
                          className="ficheck"
                          control={
                            <Checkbox
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelected([...selected, el.id])
                                } else {
                                  setSelected([...selected.filter((c) => c !== el.id)])
                                }
                              }}
                            />
                          }
                          label={el.objectives_name}
                        />
                      </TableCell>

                      <TableCell align="right">
                        {el.objectifs}
                        {''}
                        {el.unit_of_measurement}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Card>
    </>
  )
}

export default MesObjectifsCard

function AddObjectForm({ updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [selectedDomain, setSelectedDomain] = useState(null)
  const [uniteM, setUniteM] = useState('')
  const [objectifsMetadata, setObjectifsMetaDeta] = useState({
    domains: [],
    frequency: [],
    predefinedObjectives: [],
    status: [],
  })

  const [open, setOpen] = useState(false)

  const { handleSubmit, reset, setValue, control } = useForm({
    domain: null,
    objectives_name: null,
    unit_of_measurement: null,
    objectifs: null,
    periodicity: null,
    date_objectives: null,
  })

  useEffect(() => {
    fetchMesObjectifsMetaData()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setUniteM('')
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      domain: data.domain.id,
      objectives_name: data.objectives_name.id,
      periodicity: data.periodicity.id,
    }
    const response = await makePostRequest(urls.crudMesObjectifs, payload, {}, true)
    if (response.status === 201) {
      updateReports()
      handleClose()
      setOpen(false)
    }
  }
  const fetchMesObjectifsMetaData = async () => {
    const response = await makeGetRequest(urls.fetchMesObjectifsMetaData, {}, true)
    if (response.status === 200) {
      const domains = []
      const frequency = []
      const predefinedObjectives = []
      const status = [{ label: 'En cours' }, { label: 'Annulé' }, { label: 'reussite' }]
      response.data.domains.forEach((v) => {
        if (v.domain === 'Finance') {
          setSelectedDomain({ label: v.domain, id: v.id })
          setValue('domain', { label: v.domain, id: v.id })
        }
        domains.push({ label: v.domain, id: v.id })
      })
      response.data.frequency.forEach((v) => {
        frequency.push({ label: v.name_of_periodicity, id: v.id })
      })
      response.data.predefined_objectives.forEach((v) => {
        predefinedObjectives.push({
          label: v.objectives_name,
          id: v.id,
          domain: v.domain,
          value: v.value_format,
        })
      })
      setObjectifsMetaDeta({
        domains,
        frequency,
        predefinedObjectives,
        status,
      })
    }
  }
  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <AddCircleIcon sx={{ color: 'gray' }} />
      </IconButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose} className="no-drag">
        <DialogTitle sx={{ color: '#383838 !important' }}>{t('monPatrimoine.addObjectiveDialogTitle')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('domain', j)}
              label={t('monPatrimoine.domain')}
              data={objectifsMetadata.domains}
              disabled
              name="domain"
              required={true}
              selectedValue={selectedDomain}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('objectives_name', j)
                setUniteM(j.value)
                setValue('unit_of_measurement', j.value)
              }}
              label={t('monPatrimoine.objectives')}
              data={objectifsMetadata.predefinedObjectives}
              name="objectives_name"
              required={true}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              value={uniteM}
              name="unit_of_measurement"
              label={t('monPatrimoine.unitOfMeasure')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="objectifs"
              label={t('monPatrimoine.value')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'date',
              }}
              InputLabelProps={{ shrink: true }}
              rules={{ required: true }}
              name="date_objectives"
              label={t('monPatrimoine.dueDate')}
            />{' '}
            <ComboBox
              handleAutoComplete={(e, j) => setValue('periodicity', j)}
              label={t('monPatrimoine.periodicity')}
              data={objectifsMetadata.frequency}
              name="periodicity"
              required={true}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" type="submit">
              {t('monPatrimoine.validate')}
            </Button>
            <Button onClick={handleClose}>{t('monPatrimoine.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
